import { useSelector } from 'src/store';
import { selectors } from 'src/store/navbar';

export const useFilterBarState = () => useSelector(selectors.selectFilterBar);
